import React from 'react';
import {Avatar as PrimeAvatar} from "primereact/avatar"
import {Tooltip} from "primereact/tooltip";
import {resolveUrl} from "../app-config";
function Avatar({memberData,size="normal", bgColorRange=100, borderColorRange=300, onClick, className="text-2xs font-bold", style, shape="circle" ,unStyled}) {
    const abbr = (firstname, lastname)=>{
        return `${firstname?.charAt(0)??""} ${lastname?.charAt(0)??""}`
    }
    if (memberData){
        if (memberData.profileImage)return (
            <>
                <Tooltip target={`.member-name-${memberData.id}`}  className="text-2xs" />
                {!unStyled?(
                    <PrimeAvatar data-pr-tooltip={memberData.fullname} style={style} shape={shape} size={size} onClick={onClick} image={resolveUrl(memberData.profileImage?.url)} className={`member-name-${memberData.id} ${!memberData.profileImage&&"bg-"+memberData.color+`-${bgColorRange}`} border-none border-${memberData.color}-${borderColorRange}  ${onClick&&"cursor-pointer"} ${className}`}/>
                ):(
                    <PrimeAvatar data-pr-tooltip={memberData.fullname} style={style} shape={shape} size={size} onClick={onClick} image={resolveUrl(memberData.profileImage?.url)} className={`member-name-${memberData.id} ${onClick&&"cursor-pointer"} ${className}`}/>
                )}

            </>
        )
        else return (
            <>
                <Tooltip target=".member-name" className="text-2xs"/>
                {!unStyled?(
                    <PrimeAvatar data-pr-tooltip={memberData.fullname} shape={shape} style={style}  size={size} onClick={onClick} label={abbr(memberData.firstname, memberData.lastname)} className={`member-name ${!memberData.profileImage&&"bg-"+memberData.color+`-${bgColorRange}`} border-1 border-${memberData.color}-${borderColorRange}  ${onClick&&"cursor-pointer"} ${className}`}/>
                ):(
                    <PrimeAvatar data-pr-tooltip={memberData.fullname} style={style} shape={shape} size={size} onClick={onClick} label={abbr(memberData.firstname, memberData.lastname)} className={`member-name ${onClick&&"cursor-pointer"} ${className}`}/>
                )}
            </>
        )
    }
    return <></>

}

export default Avatar;
